module.exports = __webpack_public_path__ + "img/gme_modal.fc07a82f.png";